const ALLOWED_EXTENSIONS = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'csv'];

const ALLOWED_EXTENSION_SET = new Set<string>(ALLOWED_EXTENSIONS);

/** `accept` value for `<input type="file" />` (PDF, Word, Excel, CSV). */
export const PURCHASE_ORDER_DOCUMENT_ACCEPT = ALLOWED_EXTENSIONS.map(
  (ext) => `.${ext}`,
).join(',');

export function isAllowedPurchaseOrderDocumentFile(file: File): boolean {
  const name = file.name.toLowerCase();
  const dot = name.lastIndexOf('.');
  if (dot < 0) {
    return false;
  }
  const ext = name.slice(dot + 1);
  return ALLOWED_EXTENSION_SET.has(ext);
}
